/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useContext } from "react";
import { initMercadoPago, CardPayment } from "@mercadopago/sdk-react";
import {
  REACT_APP_MP_PUBLIC_KEY,
  REACT_APP_PLAN_SUPERPRO,
  REACT_APP_PLAN_SUPERPRO_ANNUAL,
  MP_PLAN_SUPER_PRO_MONTH_ID,
  MP_PLAN_SUPER_PRO_YEAR_ID,
  REACT_APP_PLAN_PRO,
  MP_PLAN_PRO_MONTH_ID,
  REACT_APP_PAYPAL_CLIENT_ID,
} from "../../env";
import { useLocation, useNavigate } from "react-router-dom";
import { convertTypeFrequency, formatterAmount } from "../../utils/utilidades";
import {
  createSuscriptionMP,
  getPlanMPById,
} from "../../utils/Api/mercadoPagoServices";
import {
  ICardPaymentBrickPayer,
  ICardPaymentFormData,
} from "@mercadopago/sdk-react/esm/bricks/cardPayment/type";
import { useCountryAndCurrency } from "../../hooks/useCountryAccess";
import moment from "moment";
import SubscriptionSkeleton from "./gatewayLoading";
import AuthContext from "../../utils/Auth";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import Checkout from "./checkoutPaypal";
import { useTranslation } from "react-i18next";
import { BsPaypal } from "react-icons/bs";
import MercadoPagoIcon from "../../utils/images/mercadopago.svg";
import { FaCheck } from "react-icons/fa";
import { IoShield } from "react-icons/io5";
import { BsFillShieldLockFill } from "react-icons/bs";

const PUBLIC_KEY = REACT_APP_MP_PUBLIC_KEY;
const GatewayPayments = () => {
  const navigate = useNavigate();
  const [t] = useTranslation("global");
  const [typeMethod, setTypeMethod] = useState<string>("");
  const { currentUser } = useContext(AuthContext);
  const { currency, language } = useCountryAndCurrency();
  const [planId, setPlanId] = useState<string>("");
  const { state } = useLocation();
  const brickContainerRef = useRef<HTMLFormElement>(null);
  const isPlanFetched = useRef(null);

  useEffect(() => {
    initMercadoPago(PUBLIC_KEY);
    return () => {
      window?.cardPaymentBrickController?.unmount();
    };
  }, []);

  const selectedMethodSubscription = (typeMethod: string) => {
    const planIds = {
      Pro: {
        monthly:
          typeMethod === "mercadoPago"
            ? MP_PLAN_PRO_MONTH_ID
            : REACT_APP_PLAN_PRO,
      },
      SuperPro: {
        monthly:
          typeMethod === "mercadoPago"
            ? MP_PLAN_SUPER_PRO_MONTH_ID
            : REACT_APP_PLAN_SUPERPRO,
        annual:
          typeMethod === "mercadoPago"
            ? MP_PLAN_SUPER_PRO_YEAR_ID
            : REACT_APP_PLAN_SUPERPRO_ANNUAL,
      },
    };

    setPlanId(planIds[state.subscriptionType][state.subscriptionFrequency]);
    setTypeMethod(typeMethod);
  };

  const handleApiError = (error: any, message: string) => {
    console.error(message, error);
  };

  const findPlan = async () => {
    try {
      const response = await getPlanMPById(planId);
      const result = response.data;
      isPlanFetched.current = result.plan;
    } catch (error) {
      handleApiError("Error al buscar el plan:", error);
    }
  };

  const onSubmit = async (
    data: ICardPaymentFormData<ICardPaymentBrickPayer>
  ) => {
    const planId = isPlanFetched.current?.id;

    createSuscriptionMP({
      preapproval_plan_id: planId,
      reason: isPlanFetched.current?.reason,
      payer_email: data.payer.email,
      card_token_id: data.token,
      auto_recurring: {
        frequency: isPlanFetched.current?.auto_recurring.frequency,
        frequency_type: isPlanFetched.current?.auto_recurring.frequency_type,
        start_date: new Date().toISOString(),
        end_date: new Date(
          new Date().setDate(new Date().getDate() + 360)
        ).toISOString(),
        transaction_amount:
          isPlanFetched.current?.auto_recurring.transaction_amount,
        currency_id: isPlanFetched.current?.auto_recurring.currency_id,
      },
      player_id: currentUser?.id_player,
      updateType:'subscription',
      recurring_type:state.subscriptionFrequency,
    })
      .then((resp: any) => {
        if (resp?.data?.status === "ok") {
          const result = resp.data.data;
          navigate("/finishPayment", {
            state: {
              suscriptionData: {
                subscriptionName: result.reason,
                currency: result.auto_recurring.currency_id,
                amount: result.auto_recurring.transaction_amount,
                frequency_type: state.subscriptionFrequency,
                start_date: result.auto_recurring.start_date,
                next_payment: result.end_date,
              },
              isSuccess: true,
              isProccessing: false,
            },
          });
        } else {
          navigate("/finishPayment", {
            state: {
              suscriptionData: {},
              isSuccess: false,
              isProccessing: false,
            },
          });
        }
      })
      .catch((error: any) => {
        console.log("error al crear la suscripción", error);
        navigate("/finishPayment", {
          state: {
            suscriptionData: {},
            isSuccess: false,
            isProccessing: false,
          },
        });
      });
  };

  if (!currency || !language || !state) {
    return <SubscriptionSkeleton />;
  }
  console.log('Que devuelve state =>',state);
  return (
    <div
      className="relative flex items-center justify-center min-h-screen p-4 bg-center bg-cover"
      style={{ backgroundImage: `url(/img/sport-tennis.jpg)` }}
    >
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl laptop:max-w-2xl laptop:">
        <h2 className="text-xl font-semibold text-center text-black">
          {t("gatewayPayments.title")}
        </h2>
        <div className="flex items-center mt-4 laptop:space-x-[10rem] ">
        <div className="flex items-center gap-4 laptop:gap-5 ">
          <div className="flex items-center justify-center w-12 h-12 p-6 text-white bg-red-600 rounded-full laptop:p-2 ring-2 ring-black">
            <span className="text-lg font-bold">
              {state ? state.subscriptionName?.slice(0, 1)?.toUpperCase() : ""}
            </span>
          </div>
          <div>
            <p className="font-medium text-black">{state.subscriptionName}</p>
            <p className="text-sm text-gray-500">
              {t("gatewayPayments.update")}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 p-4 laptop:gap-5 ">
          <img src={'/img/norton-secure.avif'} alt="norton" className="laptop:w-[8rem] w-[6rem]"/>
          <img src={'/img/pci-dss.avif'} alt="pci" className="laptop:w-[6rem] w-[4rem]"/>
        </div>
        </div>
        <div className="p-4 mt-4 bg-gray-100 rounded-md">
          <p className="text-sm text-gray-600">
            {t("gatewayPayments.cost")}{" "}
            {convertTypeFrequency(state.subscriptionFrequency)}
          </p>
          <p className="text-2xl font-semibold text-black">
            {formatterAmount(state.subscriptionAmount, currency, language)}
          </p>
          <p className="text-sm text-gray-600">
            {t("gatewayPayments.firstPayment")}: {moment().format("D MMM YYYY")}
          </p>
          <div className="flex items-center gap-2 my-2">
            <BsFillShieldLockFill className="text-blue-500" size={20} />
            <span className="text-sm font-semibold text-gray-500">
              {t("gatewayPayments.secureBanking")}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <FaCheck className="text-green-500" />
            <span className="text-sm font-semibold text-gray-500">
             {t('gatewayPayments.pciDss')}
            </span>
          </div>
        </div>

        <h3 className="mt-4 text-lg font-semibold text-black">
          {t("gatewayPayments.selectionMethod")}
        </h3>
        <div className="flex mt-2 space-x-4">
          <button
            className={`flex-1  flex flex-row gap-5 p-3 justify-center rounded-lg font-semibold ${
              typeMethod === "paypal"
                ? "bg-red-600 text-white"
                : "bg-gray-200 text-black"
            } disabled:cursor-not-allowed`}
            onClick={() => selectedMethodSubscription("paypal")}
            disabled={state.subscriptionAmount <= 0 ? true : false}
          >
            <BsPaypal className="text-2xl text-blue-600" />
            {t("gatewayPayments.Buttons.paypal")}
          </button>
          <button
            className={`flex-1  flex flex-row gap-5 justify-center item-center p-3 rounded-lg font-semibold ${
              typeMethod === "mercadoPago"
                ? "bg-red-600 text-white"
                : "bg-gray-200 text-black"
            } disabled:cursor-not-allowed`}
            onClick={() => selectedMethodSubscription("mercadoPago")}
            disabled={state.subscriptionAmount <= 0 ? true : false}
          >
            <img
              src={MercadoPagoIcon}
              className="w-[2rem] text-2xl"
              alt="mercadopago"
            />
            {t("gatewayPayments.Buttons.mercadoPago")}
          </button>
        </div>

        {typeMethod === "mercadoPago" && (
          <div className="mt-4">
            <form ref={brickContainerRef}>
              <div className="w-full my-8 border-gray-200 border-1" />
              <CardPayment
                initialization={{ amount: state.subscriptionAmount }}
                customization={{
                  paymentMethods: { maxInstallments: 1, minInstallments: 1 },
                }}
                locale={language}
                onReady={findPlan}
                onSubmit={onSubmit}
                onError={(error) => {
                  console.log("Error al crear el token de la tarjeta:", error);
                }}
              />
            </form>
          </div>
        )}

        {typeMethod === "paypal" && (
          <div className="mt-4">
            <PayPalScriptProvider
              options={{
                "client-id": REACT_APP_PAYPAL_CLIENT_ID,
                currency: "USD",
                vault: true,
                intent: "subscription",
                locale: "en_US",
                components: "buttons",
              }}
            >
              <Checkout
                currentUser={currentUser}
                idPlan={planId}
                state={state}
              />
            </PayPalScriptProvider>
          </div>
        )}

        <p className="mt-6 text-xs text-gray-500">
          {t("gatewayPayments.descriptionPaypal")}{" "}
          <span className="text-blue-500">Paypal.</span>
          <p className="my-1 text-xs font-bold text-yellow-500">
            {t("gatewayPayments.descriptionMercadoPago")}
          </p>
          <p className="my-1">{t("gatewayPayments.ivaInfo")}</p>
        </p>
        <div className="w-full p-3 mt-4 font-semibold text-black bg-yellow-100 rounded-lg">
          <p className="text-sm text-gray-500">
            <b className="text-red-400">
              {t("gatewayPayments.informationCard.title")}
            </b>
            <p>{t("gatewayPayments.informationCard.description")}</p>
          </p>
        </div>
        <p className="mt-6 text-xs font-medium text-gray-500">
          {t("gatewayPayments.cancelInformation")}
        </p>
        <div className="flex items-center gap-2 my-4">
          <IoShield className="text-red-400" size={30} />
          <span className="text-sm font-semibold text-gray-500">
           {t('gatewayPayments.secureAdditional')}
          </span>
        </div>

        <button
          className="w-full p-3 mt-4 font-semibold text-black bg-gray-300 rounded-lg"
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("gatewayPayments.Buttons.cancel")}
        </button>
      </div>
    </div>
  );
};

export default GatewayPayments;
